export const RESTAURANT_OPEN = 'Open Now';
export const RESTAURANT_CLOSED = 'Closed Now';
